import _ from 'underscore';


export default (length = 6) => _.sample('abcdefghijklmnopqrstruvxyz'.split(''), length).join('');


// WEBPACK FOOTER //
// ./src/utils/randomString.js